// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3fqwY","selects":"Documents_selects__3eJRn"};